export enum JOURNEY_STEP_TYPE {
  SOURCE_AUDIENCE = 'sourceAudience',
  SOURCE_EVENTS = 'sourceEvents',
  FLOW_INTERACTION = 'flowInteraction',
  FLOW_EVENT = 'flowEvent',
  FLOW_RANDOM = 'flowRandom',
  FLOW_SPLIT = 'flowSplit',
  FLOW_JOIN = 'flowJoin',
  FLOW_WAIT = 'flowWait',
  FLOW_WAIT_INTERACTION = 'flowWaitInteraction',
  ACTION_MESSAGE_PUSH = 'actionMessagePush',
  ACTION_MESSAGE_IN_APP = 'actionMessageInApp',
  ACTION_MESSAGE_EMAIL = 'actionMessageEmail',
  ACTION_POSTBACK = 'actionPostback',
  UPDATE_TAG_COUNT = 'updateTagCount',
  END = 'end',
}

export enum JOURNEY_STEP_CATEGORY {
  SOURCE = 'source',
  FLOW = 'flow',
  ACTION = 'action',
  UPDATE = 'update',
  END = 'end',
}

export const JOURNEY_STEP_TYPES_CATEGORY = {
  [JOURNEY_STEP_CATEGORY.SOURCE]: Object.values(JOURNEY_STEP_TYPE).filter((v) =>
    v.startsWith(JOURNEY_STEP_CATEGORY.SOURCE)
  ),
  [JOURNEY_STEP_CATEGORY.FLOW]: Object.values(JOURNEY_STEP_TYPE).filter((v) =>
    v.startsWith(JOURNEY_STEP_CATEGORY.FLOW)
  ),
  [JOURNEY_STEP_CATEGORY.ACTION]: Object.values(JOURNEY_STEP_TYPE).filter((v) =>
    v.startsWith(JOURNEY_STEP_CATEGORY.ACTION)
  ),
  [JOURNEY_STEP_CATEGORY.UPDATE]: Object.values(JOURNEY_STEP_TYPE).filter((v) =>
    v.startsWith(JOURNEY_STEP_CATEGORY.UPDATE)
  ),
  [JOURNEY_STEP_CATEGORY.END]: Object.values(JOURNEY_STEP_TYPE).filter((v) =>
    v.startsWith(JOURNEY_STEP_CATEGORY.END)
  ),
};

export enum JOURNEY_AUDIENCE_TYPE {
  STATIC = 'static',
  DYNAMIC = 'dynamic',
}

export enum JOURNEY_POSTBACK_VARIABLE {
  CUSTOMER_ID = '{{customerId}}',
  CAMPAIGN_ID = '{{campaignId}}',
  CAMPAIGN_TYPE = '{{campaignType}}',
  JOURNEY_ID = '{{journeyId}}',
  UNIX_TIME = '{{unixTime}}',
  ISO_DATE = '{{isoDate}}',
  UUID_V4 = '{{uuidV4}}',
}

export enum JOURNEY_POSTBACK_TYPE {
  HTTPS = 'https',
  INTEGRATION_ADOBE = 'adobeIntegration',
}
